import { render, staticRenderFns } from "./AddBrandVoiceByFile.vue?vue&type=template&id=867fa38a"
import script from "./AddBrandVoiceByFile.vue?vue&type=script&lang=js"
export * from "./AddBrandVoiceByFile.vue?vue&type=script&lang=js"
import style0 from "./AddBrandVoiceByFile.vue?vue&type=style&index=0&id=867fa38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports